import React from 'react';

import IconFilterDial from '@pkg/assets/icons/filter-dial.svg?react';

import { FilterAction } from '../FilterAction/FilterAction.tsx';

import { ActionWrapper } from './FiltersShowAction.style';

export interface FiltersShowActionProps {
    iconOnly?: boolean;
    pressed?: boolean;
    onToggle?: (pressed: boolean) => void;
}

export function FiltersShowAction({ iconOnly = false, pressed = false, onToggle }: FiltersShowActionProps) {
    const label = pressed ? 'Hide filters' : 'Show filters';
    const ariaLabel = pressed ? 'Hide filtering navigation' : 'Show filtering navigation';

    return (
        <ActionWrapper $iconOnly={iconOnly}>
            <FilterAction
                label={label}
                icon={<IconFilterDial />}
                ariaLabel={ariaLabel}
                iconOnly={iconOnly}
                disabled={!onToggle}
                pressed={pressed}
                onAction={onToggle ? () => onToggle(!pressed) : undefined}
            />
        </ActionWrapper>
    );
}
